export default {"src":"/_next/static/media/bg-image-planets.f88c6465.svg","height":79,"width":88,"blurWidth":0,"blurHeight":0};